import Styles from './ArticleFileIcon.module.scss'
import cx from 'classnames'
import { DocEmoji } from 'components/DocEmoji/DocEmoji'
import { externalFileEmoji, ArticleDocType } from 'components/ReviewsWizard/FileSelection/urlValidationUtils'
import { ChannelIcon } from 'components/ChannelIcon/ChannelIcon'

export interface Props {
  article?: ArticleDocType
  customClassName?: string
  gray?: boolean
}

export const ArticleFileIcon = ({ article, customClassName, gray }: Props) => {
  if (!article) return null

  return (
    <span className={cx(Styles.icon, customClassName, { [Styles.gray]: gray })}>
      {externalFileEmoji(article) || (article.channel_emoji && <ChannelIcon channel={article.channel_emoji} />) || (
        <DocEmoji emoji={article.header_emoji || null} />
      )}
    </span>
  )
}
